module.exports = __webpack_public_path__ + "img/gb-round.28f0fb56.svg";